module.exports = __webpack_public_path__ + "img/three_down_ar.a1f2705f.png";